import { render, staticRenderFns } from "./PredictedTransactionRow.vue?vue&type=template&id=48917b00&scoped=true&"
import script from "./PredictedTransactionRow.vue?vue&type=script&lang=js&"
export * from "./PredictedTransactionRow.vue?vue&type=script&lang=js&"
import style0 from "./PredictedTransactionRow.vue?vue&type=style&index=0&id=48917b00&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48917b00",
  null
  
)

export default component.exports